import React, { useEffect, useState } from 'react';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Header from '../Header/Header';
import {useLocation} from 'react-router-dom';
import { Card, CardContent, CircularProgress, makeStyles } from '@material-ui/core';
import { BFF_ONBOARDING_URL, URL_BACKOFFICE } from '../../index';
import Button from '@material-ui/core/Button';
import theme from '../../theme';

const useStyles = makeStyles({
    root : {
        margin: theme.spacing(0, 'auto'),
        fontSize: '1rem',
        maxWidth: '90%'
    }
});

const AccountCreationPage : React.FC = () => {
    const [ loading, setLoading ] = useState(true);
    const [ codeResponse, setCodeResponse ] = useState(0);
    const location = useLocation();


    useEffect( () => {
        execute();
    }, [])
    
    const execute = async () => {
        const accountRequest =  JSON.stringify(location?.state?.accountRequest)
        const data = await fetch(`${BFF_ONBOARDING_URL}/accounts`, {
            method: 'post',
            headers: {'Content-Type':'application/json'},
            body: accountRequest
        });

        setCodeResponse(data.status);
        setLoading(false);
    }

    const renderResponseCode = (code : number) => {

        switch(code) {
            case 201:
                return (
                    <Box my={4} mx="auto">
                        Validamos tu email
                        <p>¡Listo! Ya creaste tu cuenta Payway para ventas online. A la brevedad te enviaremos un e-mail con la
                            información necesaria para poder comenzar a operar
                        </p>
                        <Button href={`${URL_BACKOFFICE}`}>Ingresar</Button>
                    </Box>
                )
            default:
                return (
                    <Box my={4} mx="auto">
                        Ocurrio un error inesperado, vuelva a intentarlo mas tarde!
                    </Box>
                )
        }
    }

    const classes = useStyles();

    return (

        <div className={classes.root}>
            <Container maxWidth="md">
                <Header />
                <Card>
                    <CardContent>
                    <Box component="span" my={4}>
                        <h2>Verificando dirección de email! 📨</h2>
                    </Box>
                    { loading ? 
                        <CircularProgress size={42} />
                        :
                        renderResponseCode(codeResponse)
                    }
                    </CardContent>
                </Card>
            </Container>
        </div>
    )
}
export default AccountCreationPage;

